import React from "react";
import { Modal, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

interface CustomModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  onSkip?: () => void;
  onCancel?: () => void;
  onSubmit?: () => void;
  cancelText?: string;
  submitText?: string;
  maxWidth?: "sm" | "md" | "lg" | "xl";
  fullWidth?: boolean;
}

const CustomModal: React.FC<CustomModalProps> = ({
  open,
  onClose,
  onSkip,
  title,
  children,
  onCancel,
  onSubmit,
  cancelText = "Cancel",
  submitText = "Submit",
  maxWidth = "sm",
  fullWidth = true,
}) => {
  return (
    <Modal
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "600px",
        margin: "auto",
        background: "transparent",
      }}
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: "20px",
          backgroundColor: "white",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <MDBox
          sx={{
            background: "white",
            borderRadius: "16px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            maxWidth: maxWidth,
            width: fullWidth ? "100%" : "auto",
            padding: 3,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <MDBox display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">{title}</Typography>
            <MDButton onClick={onClose} variant="text" color="secondary">
              X
            </MDButton>
          </MDBox>

          <MDBox sx={{ flex: 1 }}>{children}</MDBox>

          <MDBox display="flex" justifyContent="space-between" gap={2}>
            <MDButton onClick={onCancel} variant="contained" color="error" sx={{ flex: 1 }}>
              {cancelText}
            </MDButton>

            {onSkip && (
              <MDButton onClick={onCancel} variant="contained" color="dark" sx={{ flex: 1 }}>
                Skip & continue
              </MDButton>
            )}

            <MDButton onClick={onSubmit} variant="contained" color="primary" sx={{ flex: 1 }}>
              {submitText}
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </Modal>
  );
};

export default CustomModal;
